// src/sections/Section9.jsx
import React, { useState, useEffect } from "react";
import CarButton from "../components/CarButton";

const Section9 = ({ immagineBg, contenuti }) => {
  const [isMobile, setIsMobile] = useState(false);
  // expanded[index] = true se la descrizione i-esima è stata espansa
  const [expanded, setExpanded] = useState({});

  // rilevo breakpoint <768px
  useEffect(() => {
    const onResize = () => {
      setIsMobile(window.innerWidth < 992);
    };
    onResize();
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  // handler per togglare l'espansione di una sezione
  const toggleExpand = (idx) => {
    setExpanded((prev) => ({
      ...prev,
      [idx]: !prev[idx],
    }));
  };

  return (
    <div
      className="container-fluid d-flex flex-column align-items-center justify-content-start position-relative"
      style={{
        padding: "76px 16px 76px 16px",
        gap: "16px",
        backgroundImage: `var(--bg-light-theme)`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      <div className="position-absolute w-100 head-onda reverse">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 1440 50"
          preserveAspectRatio="none"
          className="w-100"
        >
          <path
            fill="#fff"
            d="M0,50L80,45C160,40,320,30,480,25C640,20,800,20,960,25C1120,30,1280,40,1360,45L1440,50L1440,50L1360,50C1280,50,1120,50,960,50C800,50,640,50,480,50,320,50,160,50,80,50L0,50Z"
          ></path>
        </svg>
      </div>

      {contenuti.map((content, index) => {
        const {
          titolo1,
          sottotitolo,
          descrizione,
          immagine,
          callToAction,
          link,
        } = content;
        const isLast = index === contenuti.length - 1;

        return (
          <div key={index} className="container row mb-4">
            {/* Colonna testo */}
            <div
              className={`col-12 col-md-6 d-flex p-4 flex-column justify-content-center align-items-start`}
            >
              <div
                style={
                  isLast
                    ? {
                        backgroundColor: "var(--bg-card-evidence)",
                        padding: "20px",
                        height: "100%",
                      }
                    : {}
                }
              >
                <p className="mini-title">{sottotitolo}</p>
                <h3
                  className="text-start text-md-start title-section-2"
                  style={isLast ? { color: "white" } : {}}
                >
                  {titolo1}
                </h3>

                {/* Descrizione con clamp in mobile */}
                <div
                  style={
                    isMobile && !expanded[index]
                      ? {
                          display: "-webkit-box",
                          WebkitLineClamp: 2,
                          WebkitBoxOrient: "vertical",
                          overflow: "hidden",
                        }
                      : {}
                  }
                  className="m-0 text-start text-md-start"
                  dangerouslySetInnerHTML={{ __html: descrizione }}
                />

                {/* Bottone "Leggi di più" */}
                {isMobile && 
                  !expanded[index] && 
                  descrizione.split("\n").join(" ").length > 200 && (
                  <button
                    onClick={() => toggleExpand(index)}
                    className="btn btn-link p-0"
                  >
                    Leggi di più
                  </button>
                )}

                {/* Bottone finale, se presente */}
                {isLast && (
                  <div className="mt-4">
                    <CarButton
                    className="m-0 text-start text-md-start btn btn-two text-uppercase d-inline-block"
                    text={callToAction}
                    to={link}
                    customClass="btn btn-two d-inline text-uppercase"
                  />
                  </div>
                )}
              </div>
            </div>

            {/* Colonna immagine */}
            <div
              className={`col-12 col-md-6 d-flex justify-content-center align-items-center ${
                isLast ? "p-4" : "px-4"
              } ${index % 2 === 0 ? "" : "order-md-first"}`}
            >
              <img
                src={immagine}
                alt={titolo1}
                className={`d-block ${
                  isLast ? "d-none d-md-block" : "d-md-block"
                }`}
                style={{ maxWidth: "100%", height: "auto" }}
              />
            </div>
          </div>
        );
      })}

      <div className="position-absolute w-100 foot-onda-reverse">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 1440 50"
          preserveAspectRatio="none"
          className="w-100"
        >
          <path
            fill="#fff"
            d="M0,50L80,45C160,40,320,30,480,25C640,20,800,20,960,25C1120,30,1280,40,1360,45L1440,50L1440,50L1360,50C1280,50,1120,50,960,50C800,50,640,50,480,50,320,50,160,50,80,50L0,50Z"
          ></path>
        </svg>
      </div>
    </div>
  );
};

export default Section9;
